import { render, staticRenderFns } from "./DialogUpload.vue?vue&type=template&id=21c04912"
import script from "./DialogUpload.vue?vue&type=script&lang=js"
export * from "./DialogUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports